import { AlleGrunntyperMedDefault } from "../valideringstyper/grunntyper";

const nb_default_validering: AlleGrunntyperMedDefault = {
  ikke: {
    null: "Må fylles ut",
    blank: "Kan ikke bestå av bare blanke tegn",
    tom: "Kan ikke være tomt",
    lik: {
      verdi: "Kan ikke være lik {{messageParams.value}}",
    },
  },
  stoerre: {
    enn: "Må være større enn {{messageParams.value}}",
    eller: {
      lik: "Må være større eller lik {{messageParams.value}}",
    },
  },
  mindre: {
    eller: {
      lik: "Må være mindre eller lik {{messageParams.value}}",
    },
  },
  mellom: "Må være mellom {{messageParams.min}} og {{messageParams.max}}",
  lik: "Må være lik {{messageParams.value}}",
  min: {
    lengde: "Må være minst {{messageParams.minLength}}",
  },
  maks: {
    lengde: "Kan ikke være lengre enn {{messageParams.maxLength}}",
    size: "Kan ikke være større enn {{messageParams.maxSize}}",
  },
  true: "Noe er feil",
  ugyldig: {
    moenster: "Ikke gyldig format",
  },
  en: {
    av: "Må være en av {{messageParams.values, generic_string_list_formatter}}",
  },
  filstoerrelse: {
    totalt:
      "Total filstørrelse må være mindre enn {{messageParams.maksFilstoerrelseString}}",
  },
};
export default nb_default_validering;
